import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const capitalAmountApi = factory.get("capitalAmount");

const initialState = {
  searchBody: {},
  capitalAmount: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      name: "",
      note: "",
    },
  },
  capitalAmountTransactions: {
    capital_amount_id: null,
    searchBody: {},
    loading: false,
    dialog: false,
    data: [],
    total: 0,
    total_amount: 0,
  },
  capitalAmounts: {
    loading: false,
    data: [],
    total: 0,
    total_amount: 0,
  },
  balance: {
    loading: false,
    dialog: false,
    capital_amount_id: null,
    type: null,
    form: {
      amount: "",
    },
  },
};

export const capitalAmountSlice = createSlice({
  name: "capitalAmount",
  initialState,
  reducers: {
    setDialog: (state) => {
      state.capitalAmount.dialog = !state.capitalAmount.dialog;
    },
    setCapitalAmountTransactionsDialog: (state, { payload }) => {
      state.capitalAmountTransactions.dialog =
        !state.capitalAmountTransactions.dialog;
      state.capitalAmountTransactions.capital_amount_id = payload;
    },
    setCapitalAmountTransactionsDataTable: (state, { payload }) => {
      console.log("capital-amount-transfer GET response:", payload);
      state.capitalAmountTransactions.data = payload.data.data ?? [];
      state.capitalAmountTransactions.total = payload.data.total ?? 0;
      state.capitalAmountTransactions.total_amount =
        payload.data.total_amount ?? 0;
    },
    setDataTable: (state, { payload }) => {
      console.log("capital-amount GET response:", payload);
      state.capitalAmounts.data = payload.data.data ?? [];
      state.capitalAmounts.total = payload.data.total ?? 0;
      state.capitalAmounts.total_amount = payload.data.total_amount ?? 0;
    },
    setById: (state, { payload }) => {
      console.log("capital-amount GET BY ID response:", payload);
      state.capitalAmount.form.id = payload.id;
      state.capitalAmount.form.name = payload.name;
      state.capitalAmount.form.balance = payload.balance;
      state.capitalAmount.form.note = payload.note;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state) => {
      state.capitalAmount.form = initialState.capitalAmount.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
    setCapitalAmountTransactionsSearchBody: (state, { payload }) => {
      state.capitalAmountTransactions.searchBody = payload;
    },
    setBalanceDialog: (state, { payload }) => {
      state.balance.dialog = !state.balance.dialog;
      state.balance.capital_amount_id = payload.id;
      state.balance.type = payload.type;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
  setBalanceDialog,
  setCapitalAmountTransactionsDataTable,
  setCapitalAmountTransactionsDialog,
  setCapitalAmountTransactionsSearchBody,
} = capitalAmountSlice.actions;

export default capitalAmountSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("capitalAmounts"));
    const res = await capitalAmountApi.getAll(params);
    console.log("GET /api/v1/capital-amount response:", res);
    dispatch(setDataTable(res));
    dispatch(setLoading("capitalAmounts"));
  } catch (err) {
    dispatch(setLoading("capitalAmounts"));
    console.log("GET /api/v1/capital-amount error:", err?.response);
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const getAllCapitalAmountTransactions = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("capitalAmountTransactions"));
    const res = await capitalAmountApi.getAllTransfers(params);
    console.log("GET /api/v1/capital-amount-transfer response:", res);
    dispatch(setCapitalAmountTransactionsDataTable(res));
    dispatch(setLoading("capitalAmountTransactions"));
  } catch (err) {
    dispatch(setLoading("capitalAmountTransactions"));
    console.log("GET /api/v1/capital-amount-transfer error:", err?.response);
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("capitalAmount"));
    const res = await capitalAmountApi.getById(id);
    console.log("GET /api/v1/capital-amount/:id response:", res);
    dispatch(setById(res.data.data[0]));
    dispatch(setDialog());
    dispatch(setLoading("capitalAmount"));
  } catch (err) {
    console.log("GET /api/v1/capital-amount/:id error:", err?.response);
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      })
    );
    dispatch(setLoading("capitalAmount"));
    throw new Error(err);
  }
};

const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("capitalAmount"));
    const res = await capitalAmountApi.create(data);
    console.log("POST /api/v1/capital-amount response:", res);
    dispatch(
      showNotification({
        message: "تمت الاضافة بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll());
    dispatch(setLoading("capitalAmount"));
  } catch (err) {
    dispatch(setLoading("capitalAmount"));
    console.log("POST /api/v1/capital-amount error:", err?.response);
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const update = (id, data, _SearchBody) => async (dispatch) => {
  try {
    dispatch(setLoading("capitalAmount"));
    const res = await capitalAmountApi.update(id, data);
    console.log("PUT /api/v1/capital-amount response:", res);
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
    dispatch(setLoading("capitalAmount"));
  } catch (err) {
    dispatch(setLoading("capitalAmount"));
    console.log("PUT /api/v1/capital-amount error:", err?.response);
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const transfer = (data, _SearchBody) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("balance"));
    const res = await capitalAmountApi.createTransfer(data);
    console.log("POST /api/v1/capital-amount-transfer response:", res);
    dispatch(
      showNotification({
        message: "تم بنجاح",
        type: "success",
      })
    );
    dispatch(
      setBalanceDialog({
        id: null,
        type: null,
      })
    );
    dispatch(getAll(_SearchBody));
    const transactionsState = getState().capitalAmount.capitalAmountTransactions;
    if (transactionsState.dialog) {
      dispatch(getAllCapitalAmountTransactions(transactionsState.searchBody));
    }
    dispatch(setLoading("balance"));
  } catch (err) {
    dispatch(setLoading("balance"));
    console.log("POST /api/v1/capital-amount-transfer error:", err?.response);
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const CapitalAmount = {
  getAll,
  getById,
  create,
  update,
  transfer,
  getAllCapitalAmountTransactions,
};
